export const resolveRoleStatusRecord = (details, summary) =>
  ["status", "role_status", "is_active"].some((key) => details?.[key] !== undefined)
    ? details : summary;

export const getRoleStatus = (role) => {
  const raw = role?.status ?? role?.role_status ?? role?.is_active;
  if (typeof raw === "boolean") return raw ? "Active" : "Inactive";
  return String(raw ?? "Active").trim().toLowerCase() === "inactive" ? "Inactive" : "Active";
};

export const buildRoleStatusPayload = (status, source) =>
  source?.is_active !== undefined && source?.status === undefined && source?.role_status === undefined
    ? { is_active: status === "Active" }
    : { status };
